declare namespace $ {

	type $bog_favicon__Icon_bog_gram_1 = $mol_type_enforce<
		ReturnType< $bog_gram['Favicon_icon'] >
		,
		ReturnType< $bog_favicon['Icon'] >
	>
	type $mol_paragraph__title_bog_gram_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_7 = $mol_type_enforce<
		ReturnType< $bog_gram['compose_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_10 = $mol_type_enforce<
		ReturnType< $bog_gram['group_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_13 = $mol_type_enforce<
		ReturnType< $bog_gram['settings_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_paragraph__title_bog_gram_15 = $mol_type_enforce<
		ReturnType< $bog_gram['invite_plate_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_gram_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_17 = $mol_type_enforce<
		ReturnType< $bog_gram['invite_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_20 = $mol_type_enforce<
		ReturnType< $bog_gram['ask_plate_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_gram_22 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_bog_gram_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gram_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gram_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_button_minor__hint_bog_gram_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_27 = $mol_type_enforce<
		ReturnType< $bog_gram['settings_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_gram_field__hint_bog_gram_29 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gram_field['hint'] >
	>
	type $bog_gram_field__value_bog_gram_30 = $mol_type_enforce<
		ReturnType< $bog_gram['user_name'] >
		,
		ReturnType< $bog_gram_field['value'] >
	>
	type $mol_paragraph__title_bog_gram_31 = $mol_type_enforce<
		ReturnType< $bog_gram['my_lord'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_gram_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_bog_gram_33 = $mol_type_enforce<
		ReturnType< $bog_gram['my_lord'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_labeler__title_bog_gram_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gram_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_bog_gram_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_37 = $mol_type_enforce<
		ReturnType< $bog_gram['invite_link'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_gram_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_bog_gram_39 = $mol_type_enforce<
		ReturnType< $bog_gram['invite_link'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $bog_qr__uri_bog_gram_40 = $mol_type_enforce<
		ReturnType< $bog_gram['invite_link'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $bog_qr__gradient_stops_bog_gram_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_qr['gradient_stops'] >
	>
	type $mol_view__sub_bog_gram_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_bog_gram_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gram_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_bog_gram_46 = $mol_type_enforce<
		ReturnType< $bog_gram['notify_status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__click_bog_gram_47 = $mol_type_enforce<
		ReturnType< $bog_gram['notify_toggle'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_gram_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_bog_gram_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gram_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gram_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gram_53 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_bog_gram_54 = $mol_type_enforce<
		ReturnType< $bog_gram['account_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_bog_gram_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gram_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_page__title_bog_gram_57 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gram_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gram_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_button_minor__hint_bog_gram_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_61 = $mol_type_enforce<
		ReturnType< $bog_gram['compose_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__hint_bog_gram_63 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_64 = $mol_type_enforce<
		ReturnType< $bog_gram['peer_lord'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_gram_65 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_start'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__click_bog_gram_66 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_67 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_gram_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_69 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_70 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__click_bog_gram_71 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_join_active'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_gram_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_gram_74 = $mol_type_enforce<
		ReturnType< $bog_gram['user_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_bog_gram_75 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gram_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gram_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_button_minor__hint_bog_gram_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_79 = $mol_type_enforce<
		ReturnType< $bog_gram['group_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_80 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__hint_bog_gram_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_82 = $mol_type_enforce<
		ReturnType< $bog_gram['group_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_paragraph__title_bog_gram_83 = $mol_type_enforce<
		ReturnType< $bog_gram['group_chosen_head'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_gram_84 = $mol_type_enforce<
		ReturnType< $bog_gram['group_chosen_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_gram_85 = $mol_type_enforce<
		ReturnType< $bog_gram['group_lost_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__click_bog_gram_86 = $mol_type_enforce<
		ReturnType< $bog_gram['group_make'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_87 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_string__hint_bog_gram_88 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_89 = $mol_type_enforce<
		ReturnType< $bog_gram['group_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_gram_90 = $mol_type_enforce<
		ReturnType< $bog_gram['group_id_add'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__click_bog_gram_91 = $mol_type_enforce<
		ReturnType< $bog_gram['group_id_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_gram_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_94 = $mol_type_enforce<
		ReturnType< $bog_gram['group_id_error'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_95 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_gram_96 = $mol_type_enforce<
		ReturnType< $bog_gram['group_pick_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_bog_gram_97 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gram_98 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gram_99 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_button_minor__hint_bog_gram_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_101 = $mol_type_enforce<
		ReturnType< $bog_gram['members_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_102 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__rows_bog_gram_103 = $mol_type_enforce<
		ReturnType< $bog_gram['member_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_gram_104 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_105 = $mol_type_enforce<
		ReturnType< $bog_gram['members_add_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_106 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_gram_107 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__attr_bog_gram_108 = $mol_type_enforce<
		({ 
			'bog_gram_armed': ReturnType< $bog_gram['leave_armed'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_gram_109 = $mol_type_enforce<
		ReturnType< $bog_gram['group_leave_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_110 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_page__title_bog_gram_111 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gram_112 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gram_113 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $bog_gram_chat__title_bog_gram_114 = $mol_type_enforce<
		ReturnType< $bog_gram['chat_title'] >
		,
		ReturnType< $bog_gram_chat['title'] >
	>
	type $bog_gram_chat__members_shown_bog_gram_115 = $mol_type_enforce<
		ReturnType< $bog_gram['chat_members_shown'] >
		,
		ReturnType< $bog_gram_chat['members_shown'] >
	>
	type $bog_gram_chat__members_bog_gram_116 = $mol_type_enforce<
		ReturnType< $bog_gram['members_open'] >
		,
		ReturnType< $bog_gram_chat['members'] >
	>
	type $bog_gram_chat__note_bog_gram_117 = $mol_type_enforce<
		ReturnType< $bog_gram['chat_note'] >
		,
		ReturnType< $bog_gram_chat['note'] >
	>
	type $bog_gram_chat__note_hint_bog_gram_118 = $mol_type_enforce<
		ReturnType< $bog_gram['chat_note_hint'] >
		,
		ReturnType< $bog_gram_chat['note_hint'] >
	>
	type $bog_gram_chat__note_editable_bog_gram_119 = $mol_type_enforce<
		ReturnType< $bog_gram['chat_note_editable'] >
		,
		ReturnType< $bog_gram_chat['note_editable'] >
	>
	type $bog_gram_chat__rows_bog_gram_120 = $mol_type_enforce<
		ReturnType< $bog_gram['chat_rows'] >
		,
		ReturnType< $bog_gram_chat['rows'] >
	>
	type $bog_gram_chat__edit_mode_bog_gram_121 = $mol_type_enforce<
		ReturnType< $bog_gram['edit_mode'] >
		,
		ReturnType< $bog_gram_chat['edit_mode'] >
	>
	type $bog_gram_chat__message_text_bog_gram_122 = $mol_type_enforce<
		ReturnType< $bog_gram['message_text'] >
		,
		ReturnType< $bog_gram_chat['message_text'] >
	>
	type $bog_gram_chat__message_send_bog_gram_123 = $mol_type_enforce<
		ReturnType< $bog_gram['message_send'] >
		,
		ReturnType< $bog_gram_chat['message_send'] >
	>
	type $bog_gram_chat__edit_cancel_bog_gram_124 = $mol_type_enforce<
		ReturnType< $bog_gram['edit_cancel'] >
		,
		ReturnType< $bog_gram_chat['edit_cancel'] >
	>
	type $bog_gram_chat__close_bog_gram_125 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_close'] >
		,
		ReturnType< $bog_gram_chat['close'] >
	>
	type $bog_gram_chat__image_files_bog_gram_126 = $mol_type_enforce<
		ReturnType< $bog_gram['image_files'] >
		,
		ReturnType< $bog_gram_chat['image_files'] >
	>
	type $bog_gram_chat__image_paste_bog_gram_127 = $mol_type_enforce<
		ReturnType< $bog_gram['image_paste'] >
		,
		ReturnType< $bog_gram_chat['image_paste'] >
	>
	type $bog_gram_chat__image_over_bog_gram_128 = $mol_type_enforce<
		ReturnType< $bog_gram['image_over'] >
		,
		ReturnType< $bog_gram_chat['image_over'] >
	>
	type $bog_gram_chat__image_drop_bog_gram_129 = $mol_type_enforce<
		ReturnType< $bog_gram['image_drop'] >
		,
		ReturnType< $bog_gram_chat['image_drop'] >
	>
	type $bog_gram_chat__zoom_uri_bog_gram_130 = $mol_type_enforce<
		ReturnType< $bog_gram['zoom_uri'] >
		,
		ReturnType< $bog_gram_chat['zoom_uri'] >
	>
	type $bog_gram_chat__zoom_close_bog_gram_131 = $mol_type_enforce<
		ReturnType< $bog_gram['zoom_close'] >
		,
		ReturnType< $bog_gram_chat['zoom_close'] >
	>
	type $bog_gram_chat__voice_on_bog_gram_132 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_on'] >
		,
		ReturnType< $bog_gram_chat['voice_on'] >
	>
	type $bog_gram_chat__voice_ready_bog_gram_133 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_ready'] >
		,
		ReturnType< $bog_gram_chat['voice_ready'] >
	>
	type $bog_gram_chat__voice_clock_bog_gram_134 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_clock'] >
		,
		ReturnType< $bog_gram_chat['voice_clock'] >
	>
	type $bog_gram_chat__voice_hint_bog_gram_135 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_hint'] >
		,
		ReturnType< $bog_gram_chat['voice_hint'] >
	>
	type $bog_gram_chat__voice_press_bog_gram_136 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_press'] >
		,
		ReturnType< $bog_gram_chat['voice_press'] >
	>
	type $bog_gram_chat__voice_release_bog_gram_137 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_release'] >
		,
		ReturnType< $bog_gram_chat['voice_release'] >
	>
	type $bog_gram_chat__voice_abort_bog_gram_138 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_abort'] >
		,
		ReturnType< $bog_gram_chat['voice_abort'] >
	>
	type $bog_gram_chat__voice_cancel_bog_gram_139 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_cancel'] >
		,
		ReturnType< $bog_gram_chat['voice_cancel'] >
	>
	type $bog_gram_chat__voice_menu_bog_gram_140 = $mol_type_enforce<
		ReturnType< $bog_gram['voice_menu'] >
		,
		ReturnType< $bog_gram_chat['voice_menu'] >
	>
	type $mol_paragraph__title_bog_gram_141 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_142 = $mol_type_enforce<
		ReturnType< $bog_gram['users_empty_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_143 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_gram_144 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_bog_gram_145 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_uri'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_string__hint_bog_gram_146 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_147 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_gram_148 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_make'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__click_bog_gram_149 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_make'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_150 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_gram_151 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_152 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_153 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_154 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_155 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_join'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_156 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_157 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_158 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_forget'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_159 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_paragraph__title_bog_gram_160 = $mol_type_enforce<
		ReturnType< $bog_gram['key_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_gram_161 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_bog_gram_162 = $mol_type_enforce<
		ReturnType< $bog_gram['key_text'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $bog_qr__uri_bog_gram_163 = $mol_type_enforce<
		ReturnType< $bog_gram['key_text'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $bog_qr__gradient_stops_bog_gram_164 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_qr['gradient_stops'] >
	>
	type $mol_string__hint_bog_gram_165 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_166 = $mol_type_enforce<
		ReturnType< $bog_gram['key_input'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_paragraph__title_bog_gram_167 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open__hint_bog_gram_168 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['hint'] >
	>
	type $mol_button_open__accept_bog_gram_169 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_open__multiple_bog_gram_170 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open['multiple'] >
	>
	type $mol_button_open__files_bog_gram_171 = $mol_type_enforce<
		ReturnType< $bog_gram['key_file'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_view__sub_bog_gram_172 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_scan__found_bog_gram_173 = $mol_type_enforce<
		ReturnType< $bog_gram['key_scanned'] >
		,
		ReturnType< $bog_gram_scan['found'] >
	>
	type $mol_button_major__attr_bog_gram_174 = $mol_type_enforce<
		({ 
			'bog_gram_armed': ReturnType< $bog_gram['import_armed'] >,
		})  & ReturnType< $mol_button_major['attr'] >
		,
		ReturnType< $mol_button_major['attr'] >
	>
	type $mol_button_major__click_bog_gram_175 = $mol_type_enforce<
		ReturnType< $bog_gram['key_import'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_176 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_paragraph__title_bog_gram_177 = $mol_type_enforce<
		ReturnType< $bog_gram['key_error'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $bog_gram_avatar__id_bog_gram_178 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_avatar_id'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_179 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_180 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_181 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_182 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_183 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_184 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_185 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_186 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_187 = $mol_type_enforce<
		ReturnType< $bog_gram['archive_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_188 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_archive_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_189 = $mol_type_enforce<
		ReturnType< $bog_gram['archive_icons'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_190 = $mol_type_enforce<
		ReturnType< $bog_gram['delete_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__attr_bog_gram_191 = $mol_type_enforce<
		({ 
			'bog_gram_armed': ReturnType< $bog_gram['delete_armed'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_gram_192 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_delete_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_193 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_194 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_195 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_196 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_197 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_198 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_199 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_200 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_201 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_202 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_203 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_204 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_205 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_206 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_207 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_208 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_209 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_210 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_avatar__id_bog_gram_211 = $mol_type_enforce<
		ReturnType< $bog_gram['user_lord'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_212 = $mol_type_enforce<
		ReturnType< $bog_gram['user_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_213 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_214 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_215 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_avatar__id_bog_gram_216 = $mol_type_enforce<
		ReturnType< $bog_gram['group_pick_lord'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_217 = $mol_type_enforce<
		ReturnType< $bog_gram['group_pick_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_218 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_219 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_220 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_avatar__id_bog_gram_221 = $mol_type_enforce<
		ReturnType< $bog_gram['group_chosen_lord'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_222 = $mol_type_enforce<
		ReturnType< $bog_gram['group_chosen_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_223 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_224 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_225 = $mol_type_enforce<
		ReturnType< $bog_gram['group_chosen_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_226 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_paragraph__title_bog_gram_227 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_gram_228 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__attr_bog_gram_229 = $mol_type_enforce<
		({ 
			'bog_gram_current': ReturnType< $bog_gram['history_open'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_gram_230 = $mol_type_enforce<
		ReturnType< $bog_gram['members_history_all'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_231 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_232 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__attr_bog_gram_233 = $mol_type_enforce<
		({ 
			'bog_gram_current': ReturnType< $bog_gram['history_shut'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_gram_234 = $mol_type_enforce<
		ReturnType< $bog_gram['members_history_new'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_235 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_236 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_237 = $mol_type_enforce<
		ReturnType< $bog_gram['members_history_note'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_string__hint_bog_gram_238 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_239 = $mol_type_enforce<
		ReturnType< $bog_gram['member_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_gram_240 = $mol_type_enforce<
		ReturnType< $bog_gram['member_id_add'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__click_bog_gram_241 = $mol_type_enforce<
		ReturnType< $bog_gram['member_id_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_242 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_paragraph__title_bog_gram_243 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_244 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_gram_245 = $mol_type_enforce<
		ReturnType< $bog_gram['join_link'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_gram_246 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_bog_gram_247 = $mol_type_enforce<
		ReturnType< $bog_gram['join_link'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $bog_qr__uri_bog_gram_248 = $mol_type_enforce<
		ReturnType< $bog_gram['join_link'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $bog_qr__gradient_stops_bog_gram_249 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_qr['gradient_stops'] >
	>
	type $mol_view__sub_bog_gram_250 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_avatar__id_bog_gram_251 = $mol_type_enforce<
		ReturnType< $bog_gram['ask_lord'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_252 = $mol_type_enforce<
		ReturnType< $bog_gram['ask_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_253 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_254 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_255 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_256 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_257 = $mol_type_enforce<
		ReturnType< $bog_gram['ask_accept'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_258 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_259 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_260 = $mol_type_enforce<
		ReturnType< $bog_gram['ask_reject'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_261 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_gram_avatar__id_bog_gram_262 = $mol_type_enforce<
		ReturnType< $bog_gram['member_lord'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_263 = $mol_type_enforce<
		ReturnType< $bog_gram['member_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_264 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_265 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_266 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_267 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_268 = $mol_type_enforce<
		ReturnType< $bog_gram['member_rule_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_269 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_270 = $mol_type_enforce<
		ReturnType< $bog_gram['member_drop_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__attr_bog_gram_271 = $mol_type_enforce<
		({ 
			'bog_gram_armed': ReturnType< $bog_gram['member_armed'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_bog_gram_272 = $mol_type_enforce<
		ReturnType< $bog_gram['member_drop_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_273 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_gram_avatar__id_bog_gram_274 = $mol_type_enforce<
		ReturnType< $bog_gram['member_pick_lord'] >
		,
		ReturnType< $bog_gram_avatar['id'] >
	>
	type $bog_gram_avatar__tint_bog_gram_275 = $mol_type_enforce<
		ReturnType< $bog_gram['member_pick_tint'] >
		,
		ReturnType< $bog_gram_avatar['tint'] >
	>
	type $mol_view__sub_bog_gram_276 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_277 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_278 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_279 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_gram_280 = $mol_type_enforce<
		({ 
			'bog_gram_tint': ReturnType< $bog_gram['message_author_tint'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_gram_281 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_photo__hint_bog_gram_282 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gram_photo['hint'] >
	>
	type $bog_gram_photo__uri_bog_gram_283 = $mol_type_enforce<
		ReturnType< $bog_gram['message_shot_uri'] >
		,
		ReturnType< $bog_gram_photo['uri'] >
	>
	type $bog_gram_photo__box_width_bog_gram_284 = $mol_type_enforce<
		ReturnType< $bog_gram['message_shot_width'] >
		,
		ReturnType< $bog_gram_photo['box_width'] >
	>
	type $bog_gram_photo__box_ratio_bog_gram_285 = $mol_type_enforce<
		ReturnType< $bog_gram['message_shot_ratio'] >
		,
		ReturnType< $bog_gram_photo['box_ratio'] >
	>
	type $bog_gram_photo__click_bog_gram_286 = $mol_type_enforce<
		ReturnType< $bog_gram['message_zoom'] >
		,
		ReturnType< $bog_gram_photo['click'] >
	>
	type $bog_gram_sound__uri_bog_gram_287 = $mol_type_enforce<
		ReturnType< $bog_gram['message_sound_uri'] >
		,
		ReturnType< $bog_gram_sound['uri'] >
	>
	type $bog_gram_sound__span_bog_gram_288 = $mol_type_enforce<
		ReturnType< $bog_gram['message_sound_span'] >
		,
		ReturnType< $bog_gram_sound['span'] >
	>
	type $bog_gram_sound__playing_bog_gram_289 = $mol_type_enforce<
		ReturnType< $bog_gram['message_sound_playing'] >
		,
		ReturnType< $bog_gram_sound['playing'] >
	>
	type $bog_gram_sound__toggle_bog_gram_290 = $mol_type_enforce<
		ReturnType< $bog_gram['message_sound_toggle'] >
		,
		ReturnType< $bog_gram_sound['toggle'] >
	>
	type $bog_gram_sound__ended_bog_gram_291 = $mol_type_enforce<
		ReturnType< $bog_gram['message_sound_ended'] >
		,
		ReturnType< $bog_gram_sound['ended'] >
	>
	type $mol_paragraph__title_bog_gram_292 = $mol_type_enforce<
		ReturnType< $bog_gram['message_body'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_293 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_294 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_295 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_296 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_297 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_298 = $mol_type_enforce<
		ReturnType< $bog_gram['message_edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_299 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_300 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_301 = $mol_type_enforce<
		ReturnType< $bog_gram['message_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_302 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_303 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_304 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_305 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_306 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_gram_307 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_gram_308 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_309 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_310 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_gram_311 = $mol_type_enforce<
		ReturnType< $bog_gram['registry_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_bog_gram_312 = $mol_type_enforce<
		({ 
			'bog_gram_current': ReturnType< $bog_gram['registry_active_is'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_bog_gram_313 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_gram_314 = $mol_type_enforce<
		ReturnType< $bog_gram['key_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_315 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_paragraph__title_bog_gram_316 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_317 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_318 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_gram_319 = $mol_type_enforce<
		ReturnType< $bog_gram['key_save'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_320 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_321 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_gram_322 = $mol_type_enforce<
		ReturnType< $bog_gram['dialog_select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_bog_gram_323 = $mol_type_enforce<
		({ 
			'bog_gram_current': ReturnType< $bog_gram['dialog_current_is'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_bog_gram_324 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_325 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_326 = $mol_type_enforce<
		ReturnType< $bog_gram['saved_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_bog_gram_327 = $mol_type_enforce<
		({ 
			'bog_gram_current': ReturnType< $bog_gram['saved_current_is'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_bog_gram_328 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_329 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_330 = $mol_type_enforce<
		ReturnType< $bog_gram['archive_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_331 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_332 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_333 = $mol_type_enforce<
		ReturnType< $bog_gram['requests_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_334 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_335 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_336 = $mol_type_enforce<
		ReturnType< $bog_gram['request_accept'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_337 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_338 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_339 = $mol_type_enforce<
		ReturnType< $bog_gram['request_reject'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_340 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_gram_341 = $mol_type_enforce<
		ReturnType< $bog_gram['user_pick'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_342 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_gram_343 = $mol_type_enforce<
		ReturnType< $bog_gram['group_pick'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_bog_gram_344 = $mol_type_enforce<
		({ 
			'bog_gram_current': ReturnType< $bog_gram['group_picked_is'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_bog_gram_345 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_346 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_347 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_348 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_349 = $mol_type_enforce<
		ReturnType< $bog_gram['member_error'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_350 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_gram_351 = $mol_type_enforce<
		ReturnType< $bog_gram['member_pick_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_gram_352 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_353 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_354 = $mol_type_enforce<
		ReturnType< $bog_gram['members_asks_head'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_gram_355 = $mol_type_enforce<
		ReturnType< $bog_gram['members_ask_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_gram_356 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_357 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_gram_358 = $mol_type_enforce<
		ReturnType< $bog_gram['member_pick'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_359 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_360 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_gram_361 = $mol_type_enforce<
		({ 
			'bog_gram_out': ReturnType< $bog_gram['message_out'] >,
			'bog_gram_menu': ReturnType< $bog_gram['message_menu_is'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_gram_362 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gram['message_press'] > ): ReturnType< $bog_gram['message_press'] >,
			pointerup( next?: ReturnType< $bog_gram['message_release'] > ): ReturnType< $bog_gram['message_release'] >,
			pointercancel( next?: ReturnType< $bog_gram['message_release'] > ): ReturnType< $bog_gram['message_release'] >,
			contextmenu( next?: ReturnType< $bog_gram['message_context'] > ): ReturnType< $bog_gram['message_context'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_gram_363 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_gram extends $mol_book2 {
		Theme( ): $mol_theme_auto
		Favicon_icon( ): $mol_icon_message
		Favicon( ): $bog_favicon
		Intro_title( ): $mol_paragraph
		Intro_hint( ): $mol_paragraph
		Intro_plate( ): $mol_view
		Intro( ): $mol_view
		Status( ): $giper_baza_status
		compose_open( next?: any ): any
		Compose_open_icon( ): $mol_icon_message_plus
		Compose_open( ): $mol_button_minor
		group_open( next?: any ): any
		Group_open_icon( ): $mol_icon_account_multiple_plus
		Group_open( ): $mol_button_minor
		settings_open( next?: any ): any
		Settings_open_icon( ): $mol_icon_cog
		Settings_open( ): $mol_button_minor
		Lights( ): $mol_lights_toggle
		invite_plate_text( ): string
		Invite_plate_text( ): $mol_paragraph
		invite_drop( next?: any ): any
		Invite_drop_icon( ): $mol_icon_close
		Invite_drop( ): $mol_button_minor
		Invite_plate( ): $mol_view
		ask_plate_text( ): string
		Ask_plate_text( ): $mol_paragraph
		Ask_plate( ): $mol_view
		dialog_rows( ): readonly(any)[]
		Dialogs_list( ): $mol_list
		Menu( ): $mol_page
		settings_close( next?: any ): any
		Settings_close_icon( ): $mol_icon_close
		Settings_close( ): $mol_button_minor
		user_name( next?: string ): string
		Name_field( ): $bog_gram_field
		my_lord( ): string
		My_id_text( ): $mol_paragraph
		My_id_copy( ): $mol_button_copy
		My_id( ): $mol_labeler
		Invite_hint( ): $mol_paragraph
		invite_link( ): string
		Invite_text( ): $mol_paragraph
		Invite_copy( ): $mol_button_copy
		Invite_qr( ): $bog_qr
		Invite_qr_box( ): $mol_view
		Invite_body( ): $mol_view
		Invite( ): $mol_labeler
		notify_status( ): string
		Notify_status( ): $mol_paragraph
		notify_toggle( next?: any ): any
		notify_label( ): string
		Notify_toggle( ): $mol_button_major
		Notify_body( ): $mol_view
		Notify( ): $mol_labeler
		registry_content( ): readonly(any)[]
		Registry_block( ): $mol_labeler
		account_rows( ): readonly(any)[]
		Account_body( ): $mol_view
		Account( ): $mol_labeler
		Settings_page( ): $mol_page
		compose_close( next?: any ): any
		Compose_close_icon( ): $mol_icon_close
		Compose_close( ): $mol_button_minor
		peer_lord( next?: string ): string
		dialog_start( next?: any ): any
		Peer_field( ): $mol_string
		Peer_start( ): $mol_button_major
		Peer_form( ): $mol_view
		Users_title( ): $mol_paragraph
		Join_plate_text( ): $mol_paragraph
		registry_join_active( next?: any ): any
		Join_plate_button( ): $mol_button_major
		Join_plate( ): $mol_view
		user_rows( ): readonly(any)[]
		Users_list( ): $mol_list
		Compose_page( ): $mol_page
		group_close( next?: any ): any
		Group_close_icon( ): $mol_icon_close
		Group_close( ): $mol_button_minor
		group_name( next?: string ): string
		Group_name_field( ): $mol_string
		group_chosen_head( ): string
		Group_chosen_head( ): $mol_paragraph
		group_chosen_rows( ): readonly(any)[]
		Group_chosen_list( ): $mol_list
		group_lost_note( ): string
		Group_lost_note( ): $mol_paragraph
		group_make( next?: any ): any
		group_make_label( ): string
		Group_make( ): $mol_button_major
		group_id( next?: string ): string
		group_id_add( next?: any ): any
		Group_id_field( ): $mol_string
		Group_id_add( ): $mol_button_major
		Group_id_form( ): $mol_view
		group_id_error( ): string
		Group_id_error( ): $mol_paragraph
		Group_pick_head( ): $mol_paragraph
		group_pick_rows( ): readonly(any)[]
		Group_pick_list( ): $mol_list
		Group_page( ): $mol_page
		members_close( next?: any ): any
		Members_close_icon( ): $mol_icon_close
		Members_close( ): $mol_button_minor
		member_rows( ): readonly(any)[]
		Members_list( ): $mol_list
		Members_drop_note( ): $mol_paragraph
		members_add_rows( ): readonly(any)[]
		Members_add_block( ): $mol_view
		Members_leave_note( ): $mol_paragraph
		leave_armed( ): boolean
		group_leave_click( next?: any ): any
		group_leave_label( ): string
		Members_leave( ): $mol_button_minor
		Members_page( ): $mol_page
		chat_title( ): string
		chat_members_shown( ): boolean
		members_open( next?: any ): any
		chat_note( next?: string ): string
		chat_note_hint( ): string
		chat_note_editable( ): boolean
		chat_rows( ): readonly(any)[]
		edit_mode( ): boolean
		message_text( next?: string ): string
		message_send( next?: any ): any
		edit_cancel( next?: any ): any
		dialog_close( next?: any ): any
		image_files( next?: any ): any
		image_paste( next?: any ): any
		image_over( next?: any ): any
		image_drop( next?: any ): any
		zoom_uri( ): string
		zoom_close( next?: any ): any
		voice_on( ): boolean
		voice_ready( ): boolean
		voice_clock( ): string
		voice_hint( ): string
		voice_press( next?: any ): any
		voice_release( next?: any ): any
		voice_abort( next?: any ): any
		voice_cancel( next?: any ): any
		voice_menu( next?: any ): any
		Chat_page( ): $bog_gram_chat
		Dialogs_empty_text( ): $mol_paragraph
		users_empty_text( ): string
		Users_empty_text( ): $mol_paragraph
		registry_rows( ): readonly(any)[]
		Registry_share_text( ): $mol_paragraph
		registry_uri( ): string
		Registry_share_copy( ): $mol_button_copy
		registry_name( next?: string ): string
		registry_make( next?: any ): any
		Registry_name( ): $mol_string
		Registry_make( ): $mol_button_major
		registry_open( id: any, next?: any ): any
		registry_active_is( id: any): boolean
		registry_title( id: any): string
		Registry_title( id: any): $mol_view
		registry_status( id: any): string
		Registry_status( id: any): $mol_view
		Registry_info( id: any): $mol_view
		registry_join( id: any, next?: any ): any
		Registry_join( id: any): $mol_button_minor
		registry_forget( id: any, next?: any ): any
		Registry_drop_icon( id: any): $mol_icon_close
		Registry_drop( id: any): $mol_button_minor
		key_toggle( next?: any ): any
		key_toggle_label( ): string
		key_text( ): string
		Key_text( ): $mol_paragraph
		Key_copy( ): $mol_button_copy
		Key_qr( ): $bog_qr
		key_save( next?: any ): any
		key_input( next?: string ): string
		Key_field( ): $mol_string
		Key_load_hint( ): $mol_paragraph
		key_file( next?: any ): any
		Key_open( ): $mol_button_open
		Key_load_row( ): $mol_view
		key_scanned( next?: string ): string
		Key_scan( ): $bog_gram_scan
		import_armed( ): boolean
		key_import( next?: any ): any
		key_import_label( ): string
		Key_import( ): $mol_button_major
		key_error( ): string
		Key_error( ): $mol_paragraph
		dialog_select( id: any, next?: any ): any
		dialog_current_is( id: any): boolean
		dialog_avatar_id( id: any): string
		dialog_tint( id: any): number
		Dialog_avatar( id: any): $bog_gram_avatar
		dialog_title( id: any): string
		Dialog_title( id: any): $mol_view
		dialog_time( id: any): string
		Dialog_time( id: any): $mol_view
		Dialog_top( id: any): $mol_view
		dialog_preview( id: any): string
		Dialog_preview( id: any): $mol_view
		unread_label( id: any): string
		Unread_badge( id: any): $mol_view
		Dialog_bottom( id: any): $mol_view
		Dialog_info( id: any): $mol_view
		archive_hint( id: any): string
		dialog_archive_click( id: any, next?: any ): any
		archive_icons( id: any): readonly(any)[]
		Dialog_archive( id: any): $mol_button_minor
		delete_hint( id: any): string
		delete_armed( id: any): boolean
		dialog_delete_click( id: any, next?: any ): any
		Dialog_delete_icon( id: any): $mol_icon_delete
		Dialog_delete( id: any): $mol_button_minor
		saved_open( next?: any ): any
		saved_current_is( ): boolean
		Saved_avatar_icon( ): $mol_icon_bookmark
		Saved_avatar( ): $mol_view
		saved_title( ): string
		Saved_title( ): $mol_view
		saved_time( ): string
		Saved_time( ): $mol_view
		Saved_top( ): $mol_view
		saved_preview( ): string
		Saved_preview( ): $mol_view
		Saved_bottom( ): $mol_view
		Saved_info( ): $mol_view
		archive_toggle( next?: any ): any
		Archive_avatar_icon( ): $mol_icon_archive
		Archive_avatar( ): $mol_view
		Archive_title( ): $mol_view
		archive_note( ): string
		Archive_note( ): $mol_view
		Archive_info( ): $mol_view
		archive_unread_label( ): string
		Archive_unread( ): $mol_view
		requests_toggle( next?: any ): any
		Requests_avatar_icon( ): $mol_icon_account_question
		Requests_avatar( ): $mol_view
		Requests_title( ): $mol_view
		Requests_note( ): $mol_view
		Requests_info( ): $mol_view
		requests_count_label( ): string
		Requests_count( ): $mol_view
		request_accept( id: any, next?: any ): any
		Request_accept_icon( id: any): $mol_icon_check
		request_reject( id: any, next?: any ): any
		Request_reject_icon( id: any): $mol_icon_close
		user_pick( id: any, next?: any ): any
		user_lord( id: any): string
		user_tint( id: any): number
		User_avatar( id: any): $bog_gram_avatar
		user_title( id: any): string
		User_title( id: any): $mol_view
		user_source( id: any): string
		User_source( id: any): $mol_view
		User_info( id: any): $mol_view
		group_pick( id: any, next?: any ): any
		group_picked_is( id: any): boolean
		group_pick_lord( id: any): string
		group_pick_tint( id: any): number
		Group_pick_avatar( id: any): $bog_gram_avatar
		group_pick_title( id: any): string
		Group_pick_title( id: any): $mol_view
		group_pick_source( id: any): string
		Group_pick_source( id: any): $mol_view
		Group_pick_info( id: any): $mol_view
		Group_pick_mark( id: any): $mol_icon_check
		group_chosen_lord( id: any): string
		group_chosen_tint( id: any): number
		Group_chosen_avatar( id: any): $bog_gram_avatar
		group_chosen_name( id: any): string
		Group_chosen_name( id: any): $mol_view
		group_chosen_drop( id: any, next?: any ): any
		Group_chosen_drop_icon( id: any): $mol_icon_close
		Group_chosen_drop( id: any): $mol_button_minor
		Members_history_head( ): $mol_paragraph
		history_open( ): boolean
		members_history_all( next?: any ): any
		Members_history_all( ): $mol_button_minor
		history_shut( ): boolean
		members_history_new( next?: any ): any
		Members_history_new( ): $mol_button_minor
		Members_history_row( ): $mol_view
		members_history_note( ): string
		Members_history_note( ): $mol_paragraph
		member_error( ): string
		member_id( next?: string ): string
		member_id_add( next?: any ): any
		Members_id_field( ): $mol_string
		Members_id_add( ): $mol_button_major
		member_pick_rows( ): readonly(any)[]
		Members_join_head( ): $mol_paragraph
		Members_join_hint( ): $mol_paragraph
		join_link( ): string
		Members_join_text( ): $mol_paragraph
		Members_join_copy( ): $mol_button_copy
		Members_join_qr( ): $bog_qr
		Members_join_qr_box( ): $mol_view
		members_asks_head( ): string
		members_ask_rows( ): readonly(any)[]
		ask_lord( id: any): string
		ask_tint( id: any): number
		Ask_avatar( id: any): $bog_gram_avatar
		ask_title( id: any): string
		Ask_title( id: any): $mol_view
		ask_status( id: any): string
		Ask_status( id: any): $mol_view
		Ask_info( id: any): $mol_view
		ask_accept( id: any, next?: any ): any
		Ask_accept_icon( id: any): $mol_icon_check
		Ask_accept( id: any): $mol_button_minor
		ask_reject( id: any, next?: any ): any
		Ask_reject_icon( id: any): $mol_icon_close
		Ask_reject( id: any): $mol_button_minor
		member_lord( id: any): string
		member_tint( id: any): number
		Member_avatar( id: any): $bog_gram_avatar
		member_title( id: any): string
		Member_title( id: any): $mol_view
		member_status( id: any): string
		Member_status( id: any): $mol_view
		Member_info( id: any): $mol_view
		member_rule_click( id: any, next?: any ): any
		Member_rule_icon( id: any): $mol_icon_shield_crown
		Member_rule( id: any): $mol_button_minor
		member_drop_hint( id: any): string
		member_armed( id: any): boolean
		member_drop_click( id: any, next?: any ): any
		Member_drop_icon( id: any): $mol_icon_account_remove
		Member_drop( id: any): $mol_button_minor
		member_pick( id: any, next?: any ): any
		member_pick_lord( id: any): string
		member_pick_tint( id: any): number
		Member_pick_avatar( id: any): $bog_gram_avatar
		member_pick_title( id: any): string
		Member_pick_title( id: any): $mol_view
		member_pick_source( id: any): string
		Member_pick_source( id: any): $mol_view
		Member_pick_info( id: any): $mol_view
		Member_pick_mark( id: any): $mol_icon_account_plus
		day_title( id: any): string
		Day_chip( id: any): $mol_view
		message_out( id: any): boolean
		message_menu_is( id: any): boolean
		message_press( id: any, next?: any ): any
		message_release( id: any, next?: any ): any
		message_context( id: any, next?: any ): any
		message_author_tint( id: any): number
		message_author( id: any): string
		Message_author( id: any): $mol_view
		message_shot_uri( id: any): string
		message_shot_width( id: any): string
		message_shot_ratio( id: any): string
		message_zoom( id: any, next?: any ): any
		Message_shot( id: any): $bog_gram_photo
		message_sound_uri( id: any): string
		message_sound_span( id: any): number
		message_sound_playing( id: any): boolean
		message_sound_toggle( id: any, next?: any ): any
		message_sound_ended( id: any, next?: any ): any
		Message_sound( id: any): $bog_gram_sound
		message_body( id: any): string
		Message_body( id: any): $mol_paragraph
		message_time( id: any): string
		Message_time( id: any): $mol_view
		Message_edited( id: any): $mol_view
		message_checks( id: any): string
		Message_checks( id: any): $mol_view
		Message_meta( id: any): $mol_view
		message_edit( id: any, next?: any ): any
		Message_edit_icon( id: any): $mol_icon_pencil
		Message_edit( id: any): $mol_button_minor
		message_delete( id: any, next?: any ): any
		Message_delete_icon( id: any): $mol_icon_delete
		Message_delete( id: any): $mol_button_minor
		Message_actions( id: any): $mol_view
		plugins( ): readonly(any)[]
		Placeholder( ): ReturnType< $bog_gram['Intro'] >
		pages( ): readonly(any)[]
		Dialogs_empty( ): $mol_view
		Users_empty( ): $mol_view
		Registry_empty( ): $mol_paragraph
		Registry_list( ): $mol_list
		Registry_note( ): $mol_paragraph
		Registry_share( ): $mol_view
		Registry_form( ): $mol_view
		Registry_row( id: any): $mol_button_minor
		Key_toggle( ): $mol_button_minor
		Key_warning( ): $mol_paragraph
		Key_row( ): $mol_view
		Key_qr_box( ): $mol_view
		Key_save( ): $mol_button_minor
		Key_import_form( ): $mol_view
		Dialog_row( id: any): $mol_button_minor
		Dialog_archive_icon( id: any): $mol_icon_archive_arrow_down
		Dialog_unarchive_icon( id: any): $mol_icon_archive_arrow_up
		Saved_row( ): $mol_button_minor
		Archive_row( ): $mol_button_minor
		Requests_row( ): $mol_button_minor
		Request_accept( id: any): $mol_button_minor
		Request_reject( id: any): $mol_button_minor
		User_row( id: any): $mol_button_minor
		Group_pick_row( id: any): $mol_button_minor
		Group_chosen_row( id: any): $mol_view
		Members_add_title( ): $mol_paragraph
		Members_history( ): $mol_view
		Members_error( ): $mol_paragraph
		Members_id_form( ): $mol_view
		Members_pick_list( ): $mol_list
		Members_admin_note( ): $mol_paragraph
		Members_join( ): $mol_view
		Members_asks_head( ): $mol_paragraph
		Members_asks_list( ): $mol_list
		Ask_row( id: any): $mol_view
		Member_row( id: any): $mol_view
		Member_pick_row( id: any): $mol_button_minor
		Day_row( id: any): $mol_view
		Message_row( id: any): $mol_view
	}
	
	type $mol_string_button__hint_bog_gram_field_1 = $mol_type_enforce<
		ReturnType< $bog_gram_field['hint'] >
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_gram_field_2 = $mol_type_enforce<
		ReturnType< $bog_gram_field['value'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	export class $bog_gram_field extends $mol_view {
		value( next?: string ): string
		Field( ): $mol_string_button
		Edit_icon( ): $mol_icon_pencil
		hint( ): string
		sub( ): readonly(any)[]
	}
	
	type $bog_gram_field__hint_bog_gram_chat_1 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['note_hint'] >
		,
		ReturnType< $bog_gram_field['hint'] >
	>
	type $bog_gram_field__value_bog_gram_chat_2 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['note'] >
		,
		ReturnType< $bog_gram_field['value'] >
	>
	type $mol_view__sub_bog_gram_chat_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_chat_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_chat_5 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_chat_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_chat_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_chat_8 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['members'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_chat_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_chat_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_chat_11 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_chat_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__rows_bog_gram_chat_13 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_gram_chat_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_gram_chat_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_chat_16 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['edit_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_chat_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_chat_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_gram_chat_19 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['voice_hint'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_gram_chat_20 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['send_tools'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_chat_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_chat_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_chat_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_zoom__uri_bog_gram_chat_24 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['zoom_uri'] >
		,
		ReturnType< $bog_gram_zoom['uri'] >
	>
	type $bog_gram_zoom__close_bog_gram_chat_25 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['zoom_close'] >
		,
		ReturnType< $bog_gram_zoom['close'] >
	>
	type $mol_button_open__hint_bog_gram_chat_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['hint'] >
	>
	type $mol_button_open__accept_bog_gram_chat_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_open__multiple_bog_gram_chat_28 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open['multiple'] >
	>
	type $mol_button_open__files_bog_gram_chat_29 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['image_files'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_button_open__Icon_bog_gram_chat_30 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['Attach_icon'] >
		,
		ReturnType< $mol_button_open['Icon'] >
	>
	type $mol_string__hint_bog_gram_chat_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_gram_chat_32 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['message_text'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_gram_chat_33 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['message_send'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__hint_bog_gram_chat_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['hint'] >
	>
	type $mol_button_major__click_bog_gram_chat_35 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['message_send'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_gram_chat_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_chat_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__event_bog_gram_chat_38 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gram_chat['voice_press'] > ): ReturnType< $bog_gram_chat['voice_press'] >,
			pointerup( next?: ReturnType< $bog_gram_chat['voice_release'] > ): ReturnType< $bog_gram_chat['voice_release'] >,
			pointercancel( next?: ReturnType< $bog_gram_chat['voice_abort'] > ): ReturnType< $bog_gram_chat['voice_abort'] >,
			contextmenu( next?: ReturnType< $bog_gram_chat['voice_menu'] > ): ReturnType< $bog_gram_chat['voice_menu'] >,
		})  & ReturnType< $mol_button_minor['event'] >
		,
		ReturnType< $mol_button_minor['event'] >
	>
	type $mol_button_minor__sub_bog_gram_chat_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_gram_chat_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_gram_chat_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_chat_42 = $mol_type_enforce<
		ReturnType< $bog_gram_chat['voice_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_chat_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_gram_chat extends $mol_page {
		image_paste( next?: any ): any
		image_over( next?: any ): any
		image_drop( next?: any ): any
		zoom_close( next?: any ): any
		note_hint( ): string
		note( next?: string ): string
		Note_field( ): $bog_gram_field
		Title_text( ): $mol_view
		close( next?: any ): any
		Back_icon( ): $mol_icon_arrow_left
		Back( ): $mol_button_minor
		members( next?: any ): any
		Members_icon( ): $mol_icon_account_multiple
		Members( ): $mol_button_minor
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		Messages( ): $mol_list
		Edit_banner_text( ): $mol_paragraph
		edit_cancel( next?: any ): any
		Edit_cancel_icon( ): $mol_icon_close
		Edit_cancel( ): $mol_button_minor
		Edit_banner( ): $mol_view
		Voice_note( ): $mol_paragraph
		send_tools( ): readonly(any)[]
		Send_row( ): $mol_view
		Foot( ): $mol_view
		image_files( next?: any ): any
		Attach_icon( ): $mol_icon_paperclip
		message_text( next?: string ): string
		message_send( next?: any ): any
		Send_icon( ): $mol_icon_send
		voice_press( next?: any ): any
		voice_release( next?: any ): any
		voice_abort( next?: any ): any
		voice_menu( next?: any ): any
		Voice_icon( ): $mol_icon_microphone
		Record_dot( ): $mol_view
		Record_time( ): $mol_view
		voice_cancel( next?: any ): any
		Voice_cancel_icon( ): $mol_icon_close
		Voice_cancel_text( ): $mol_view
		rows( ): readonly($mol_view)[]
		edit_mode( ): boolean
		note_editable( ): boolean
		members_shown( ): boolean
		zoom_uri( ): string
		voice_on( ): boolean
		voice_ready( ): boolean
		voice_clock( ): string
		voice_hint( ): string
		event( ): ({ 
			paste( next?: ReturnType< $bog_gram_chat['image_paste'] > ): ReturnType< $bog_gram_chat['image_paste'] >,
			dragover( next?: ReturnType< $bog_gram_chat['image_over'] > ): ReturnType< $bog_gram_chat['image_over'] >,
			drop( next?: ReturnType< $bog_gram_chat['image_drop'] > ): ReturnType< $bog_gram_chat['image_drop'] >,
		})  & ReturnType< $mol_page['event'] >
		Zoom( ): $bog_gram_zoom
		title_content( ): readonly(any)[]
		head( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		Attach( ): $mol_button_open
		Message_field( ): $mol_string
		Send( ): $mol_button_major
		Voice( ): $mol_button_minor
		Record_state( ): $mol_view
		Voice_cancel( ): $mol_button_minor
	}
	
	export class $bog_gram_avatar extends $mol_avatar {
		id( ): string
		tint( ): number
		attr( ): ({ 
			'bog_gram_tint': ReturnType< $bog_gram_avatar['tint'] >,
		})  & ReturnType< $mol_avatar['attr'] >
	}
	
	type $mol_image__uri_bog_gram_photo_1 = $mol_type_enforce<
		ReturnType< $bog_gram_photo['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	export class $bog_gram_photo extends $mol_button {
		Image( ): $mol_image
		uri( ): string
		box_width( ): string
		box_ratio( ): string
		style( ): ({ 
			'width': ReturnType< $bog_gram_photo['box_width'] >,
			'aspectRatio': ReturnType< $bog_gram_photo['box_ratio'] >,
		}) 
		sub( ): readonly(any)[]
	}
	
	type $mol_button_minor__hint_bog_gram_sound_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_gram_sound_2 = $mol_type_enforce<
		ReturnType< $bog_gram_sound['toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_gram_sound_3 = $mol_type_enforce<
		ReturnType< $bog_gram_sound['toggle_icons'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__style_bog_gram_sound_4 = $mol_type_enforce<
		({ 
			'width': ReturnType< $bog_gram_sound['fill_width'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_gram_sound_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gram_sound_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gram_sound_node__uri_bog_gram_sound_7 = $mol_type_enforce<
		ReturnType< $bog_gram_sound['uri'] >
		,
		ReturnType< $bog_gram_sound_node['uri'] >
	>
	type $bog_gram_sound_node__ended_bog_gram_sound_8 = $mol_type_enforce<
		ReturnType< $bog_gram_sound['ended'] >
		,
		ReturnType< $bog_gram_sound_node['ended'] >
	>
	export class $bog_gram_sound extends $mol_view {
		toggle( next?: any ): any
		toggle_icons( ): readonly(any)[]
		Toggle( ): $mol_button_minor
		fill_width( ): string
		Fill( ): $mol_view
		Track( ): $mol_view
		stamp( ): string
		Stamp( ): $mol_view
		ended( next?: any ): any
		Node( ): $bog_gram_sound_node
		uri( ): string
		span( ): number
		playing( ): boolean
		sub( ): readonly(any)[]
		Play_icon( ): $mol_icon_play
		Pause_icon( ): $mol_icon_pause
	}
	
	export class $bog_gram_sound_node extends $mol_view {
		retime( next?: any ): any
		ended( next?: any ): any
		dom_name( ): string
		uri( ): string
		attr( ): ({ 
			'src': ReturnType< $bog_gram_sound_node['uri'] >,
			'preload': string,
		})  & ReturnType< $mol_view['attr'] >
		event( ): ({ 
			timeupdate( next?: ReturnType< $bog_gram_sound_node['retime'] > ): ReturnType< $bog_gram_sound_node['retime'] >,
			ended( next?: ReturnType< $bog_gram_sound_node['ended'] > ): ReturnType< $bog_gram_sound_node['ended'] >,
		})  & ReturnType< $mol_view['event'] >
	}
	
	type $mol_hotkey__key_bog_gram_zoom_1 = $mol_type_enforce<
		({ 
			escape( next?: ReturnType< $bog_gram_zoom['close'] > ): ReturnType< $bog_gram_zoom['close'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_image__uri_bog_gram_zoom_2 = $mol_type_enforce<
		ReturnType< $bog_gram_zoom['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	export class $bog_gram_zoom extends $mol_view {
		tab_index( ): number
		close( next?: any ): any
		Hotkey( ): $mol_hotkey
		Shot( ): $mol_image
		uri( ): string
		attr( ): ({ 
			'tabindex': ReturnType< $bog_gram_zoom['tab_index'] >,
		})  & ReturnType< $mol_view['attr'] >
		event( ): ({ 
			click( next?: ReturnType< $bog_gram_zoom['close'] > ): ReturnType< $bog_gram_zoom['close'] >,
		})  & ReturnType< $mol_view['event'] >
		plugins( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=gram.view.tree.d.ts.map